import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

export interface User { id: string; email: string; name: string; role: string; phone?: string; mfa_enabled?: boolean }
interface AuthCtx { user: User | null | false; setUser: (u: User | false) => void; logout: () => Promise<void>; isStaff: boolean }

const Ctx = createContext<AuthCtx>({ user: null, setUser: () => {}, logout: async () => {}, isStaff: false });

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<User | null | false>(null);
  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);
  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  }, []);
  const isStaff = !!user && ["owner", "admin", "staff"].includes(user.role);
  return <Ctx.Provider value={{ user, setUser, logout, isStaff }}>{children}</Ctx.Provider>;
};

export const useAuth = () => useContext(Ctx);
